import { Option } from '@sapphire/result';
import { BasePayloadMapper, Nullable } from '@ps/utils';
import {
  DecipherTargetDto,
  PutDecipherMappingsPayloadDto,
} from '../dtos/decipher-mapping.dto';
import {
  OptionMapping,
  QuestionMapping,
} from '../../state/decipher/decipher-mapping-state.model';
import { unitsForQualificationCode } from '../../decipher-mapping.constants';

type WireMapping = PutDecipherMappingsPayloadDto['mappings'][number];

export class DecipherMappingPayloadMapper extends BasePayloadMapper<
  QuestionMapping,
  WireMapping[]
> {
  public override toPayload(model: QuestionMapping): WireMapping[] {
    const qualificationCode = model.qualificationCodes[0];
    return model.targets
      .filter((target) => target.optionMappings.length > 0)
      .map((target) => ({
        mappingId: target.decipherCondition,
        desc: target.description,
        target: [
          this._toTargetDto(target.optionMappings[0], qualificationCode),
        ],
      }));
  }

  private _toTargetDto(
    optionMapping: OptionMapping,
    qualificationCode: number,
  ): DecipherTargetDto {
    if (optionMapping.kind === 'range') {
      return {
        qualification_code: qualificationCode,
        range_sets: [
          {
            from: optionMapping.range.from,
            to: optionMapping.range.to,
            ...Option.from(unitsForQualificationCode(qualificationCode)).mapOr(
              {},
              (units) => ({ units }),
            ),
          },
        ],
      };
    }
    return {
      qualification_code: qualificationCode,
      condition_codes:
        optionMapping.conditionCodes.filter(isValidConditionCode),
    };
  }
}

function isValidConditionCode(code: Nullable<string>): code is string {
  return !!code;
}
